module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--other-527d8a744767250699bf2ee9732a850e.png";